<template>
    <a href="#" @click="logout">
        <slot />
    </a>
</template>

<script>
    /* API */
    import Api from '@/api/index.js';
    import Auth from '@/api/auth.js';
    /* Constants */
    import {
        AUTH_LOGIN_URL
    } from '@/constants/auth.js';
    export default {
        name: 'app-logout',
        methods: {
            logout() {
                Auth.logout().then(response => {
                    this.$router.push({ path: AUTH_LOGIN_URL });
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Logout.vue